<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: "bg-[--theme-lightest]",
  },
})

const products = useProductVariantsStore()
</script>

<template>
  <div>
    <UHeader
      :product="products.activeProduct"
      class="px-8 lg:px-40"
    />
    <main class="flex w-full items-center justify-center lg:mt-10">
      <div class="grow">
        <slot />
      </div>
    </main>
  </div>
  <UMarketingFooter />
</template>
